import { _getAxios, _getAxiosWithoutInterceptor } from './serviceMain';

export async function getPrivacyDocument(groupCode: string, storeCode: string, card: string) {

    const queryParams = new URLSearchParams({
        groupCode: groupCode,
        storeCode: storeCode,
        card: card
      });

  const url = '/v3/customer/privacy';
  return await _getAxios(url, "", "", queryParams);
}

export async function getPrivacyDocumentWithoutInterceptor(groupCode: string, storeCode: string, card: string) {

  const queryParams = new URLSearchParams({
      groupCode: groupCode,
      storeCode: storeCode,
      card: card
    });

const url = '/v3/customer/privacy';
return await _getAxiosWithoutInterceptor(url, "", "", queryParams);
}